import { CloseIcon } from 'components/icons/CloseIcon';
import { toHHMMSS } from 'utils/datetimeParser';

interface IDuplicatedDisplayTime {
  onCancel: () => void;
  pollData: any[];
}

export default function DuplicatedDisplayTime({ onCancel, pollData }: IDuplicatedDisplayTime) {
  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300  bg-white p-7 w-screen md:w-[520px] md:min-h-[100px] rounded-lg">
        <div className="flex mb-5">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Could not save changes</span>
          <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
        </div>
        <p>The following selected polls have the same display time:</p>
        <ul className="pt-3 list-disc">
          {pollData.map((item: any) => (
            <li key={item.hash_id} className="ml-5">
              {item.title} &nbsp;&nbsp;&nbsp;<span className="text-red-main">{toHHMMSS(item.display_time)}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
